import React from "react";

const ApprovalPendingModal = ({ onClose }) => {
  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999, padding: "1rem",
      }}
    >
      <div style={{
        background: "#fff", borderRadius: "16px", width: "100%",
        maxWidth: "480px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
      }}>
        {/* Header */}
        <div style={{ background: "#f9f9f7", padding: "2rem 1.5rem 1.5rem", textAlign: "center", borderBottom: "1px solid #eee" }}>
          <div style={{
            width: 56, height: 56, borderRadius: "50%", background: "#FEF3C7",
            border: "1px solid #FCD34D", display: "flex", alignItems: "center",
            justifyContent: "center", margin: "0 auto 1rem", fontSize: 24,
          }}>⏳</div>
          <p style={{ fontSize: 18, fontWeight: 500, margin: "0 0 6px" }}>Approval pending</p>
          <p style={{ fontSize: 13, color: "#666", margin: 0 }}>
            Your profile is under review by our admin team.
          </p>
        </div>

        <div style={{ padding: "1.25rem 1.5rem" }}>
          <p style={{ fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.05em", margin: "0 0 12px" }}>
            To speed up approval
          </p>

          {/* Steps */}
          {[
            { icon: "✅", title: "Complete your business profile", desc: "Fill in all required fields including account details" },
            { icon: "📋", title: "Add your service details", desc: "Ensure services, pricing and schedule are configured" },
            { icon: "📞", title: "Reach out to our admin team", desc: "Use the contact options below to connect directly" },
          ].map((step, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "flex-start", gap: 12,
              padding: 12, borderRadius: 8, border: "1px solid #eee",
              background: "#f9f9f7", marginBottom: 8,
            }}>
              <span style={{ fontSize: 16, marginTop: 1 }}>{step.icon}</span>
              <div>
                <p style={{ fontSize: 13, fontWeight: 500, margin: "0 0 2px" }}>{step.title}</p>
                <p style={{ fontSize: 12, color: "#666", margin: 0 }}>{step.desc}</p>
              </div>
            </div>
          ))}

          <p style={{ fontSize: 11, fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.05em", margin: "1rem 0 10px" }}>
            Reach us directly
          </p>

          {/* Contact buttons */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: "1.25rem" }}>
            {[
              { icon: "📞", label: "Call support", sub: "+91 98765 43210", href: "tel:+919876543210" },
              { icon: "✉️", label: "Email support", sub: "support@yuukke.com", href: "mailto:support@yuukke.com" },
              { icon: "💬", label: "WhatsApp", sub: "Chat with our team", href: "https://wa.me/919876543210" },
            ].map((c, i) => (
              <a key={i} href={c.href} style={{
                display: "flex", flexDirection: "column", alignItems: "center",
                gap: 6, padding: "12px 8px", borderRadius: 8, border: "1px solid #eee",
                textDecoration: "none", background: "#f9f9f7", cursor: "pointer",
              }}>
                <span style={{ fontSize: 18 }}>{c.icon}</span>
                <span style={{ fontSize: 11, fontWeight: 500, color: "#111", textAlign: "center" }}>{c.label}</span>
                <span style={{ fontSize: 10, color: "#666", textAlign: "center" }}>{c.sub}</span>
              </a>
            ))}
          </div>

          <button onClick={onClose} style={{
            width: "100%", padding: 10, borderRadius: 8, border: "1px solid #ddd",
            background: "transparent", fontSize: 13, cursor: "pointer",
          }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalPendingModal;